const IconHome = ({
                    fill = "#57585A",
                    width = "18",
                    height = "18",
                    className = "",
                  }) => {
  return (
      <svg
          width={width}
          height={height}
          className={className ? className : null}
          viewBox="0 0 21 21"
          xmlns="http://www.w3.org/2000/svg"
      >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.7821 0.310102C11.573 0.110071 11.2957 0 11 0C10.7049 0 10.4271 0.110071 10.2181 0.310102L0.276572 9.83237C-0.0566729 10.1513 -0.0178377 10.4253 0.0349454 10.5553C0.088002 10.6859 0.245668 10.9122 0.707861 10.9122H1.82725V19.3756C1.82725 20.2559 2.59123 21 3.45627 21H8.49569V15.2638H13.3721V21H18.5434C19.4117 21 20.1394 20.2411 20.1394 19.3756V10.9122H21.2922C21.7549 10.9122 21.9122 10.6859 21.9651 10.5553C22.0176 10.4253 22.057 10.1513 21.724 9.83237L11.7821 0.310102Z"
            fill={fill}
        ></path>
      </svg>
  );
};
export default IconHome;
